import React            from 'react';

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    createComponentClasses() {
        let {
            className,
            isOpened,
            isDisabled,
            menuPosition
        } = this.props;

        let classNames = ['simprakit-dropdown'];
        if (isOpened)                  classNames.push('opened');
        if (isDisabled)                classNames.push('disabled');
        if (menuPosition)              classNames.push(menuPosition);
        if (className)                 Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }


    render(){
        let p = this.props;
        return(
            <div 
                className   = { this.createComponentClasses() }
                onMouseOut  = { () => p.onMouseOut() }    
            >
                { p.children }
            </div>
        )
    }
}

export default Container;